// import { navRouterMap } from "@/router";
import Cookies from "js-cookie";

const state = {
  language: Cookies.get("language") || "zh",
  //  路由
  routers: [],
  userRouters: [],
  userInfo: null,
  buckets: {}, // 旧的buckets数据（用于getOssBuckets）
  bucketData: {}, // 新的bucket数据（用于getBucketData，对齐galaxy）
  hasData: [],
  categories: [],
  channels: [],
  //  弹窗
  popup: {
    appModal: false,
    addPopup: false,
    addChannelPopup: false,
    addPopupImg: false,
    addBooks: false,
    addRootNodeBooks: false,
    addEditRootNodeBooks: false,
    delPopup: false,
    showAddBooksList: false,
    showRefreshBooksList: false,
    delFacility: false,
    appendPopup: false,
    macPopup: false,
    showCreateOrg: false,
    showPushChannel: false,
    showClassifyEditBoobsLis: false,
    showDateTimePicker: false,
    showAddBookList: false,
    showClassifyEdit: false,
    showBatchUpload: false
  },
  //  侧边导航
  navCtrl: false,
  selectShow: false,
  isSelectOverall: false,
  isHandle: " ",
  // ============== IM消息相关 ===============
  imSessionList: [],
  imMsgList: [],
  ctrlItem: null,
  nextReqMessageID: "",
  isCompleted: false, // 当前会话消息列表是否已经拉完了所有消息

  // ============== CB反馈消息相关 ================
  feedbackDbName: 'boox-message',
  cbUserList: [],
  cbMsgList: [],
  cbCurrentUser: null,
};

export default state;
